
//import myEnv from './env.json'

const myEnv = process.env
//console.log(myEnv)
/*
functions permettant l'appel au serveur node local pour effectuer
 - les lectures des repertoires locaux
 - les appels à nakala (CORS)
 - le resultat est toujours sous la forme
    retour.reponse (variable de forme string, objet suivant les cas)
    retour.erreur (vide si pas d'erreur et le texte de l'erreur sinon)
*/

const protocole = myEnv.REACT_APP_SERVERPROTOCOLE
const host = myEnv.REACT_APP_SERVERHOSTNAME
const port = myEnv.REACT_APP_SERVERPORT

const url_base_zotero = myEnv.REACT_APP_URL_BASE_ZOTERO
const api_version_zotero = myEnv.REACT_APP_URL_BASE_ZOTERO
const key_zotero = myEnv.REACT_APP_KEY_ZOTERO

const authorization_nuxeo = myEnv.REACT_APP_AUTH_NUXEO

const apiTheatra = `${protocole}${host}:${port}`;

const elements = [
    'notice'
    ,'theatre'
    ,'auteur'
    ,'collaborateur'
    ,'motclef'
    ,'phototheatre'
    ,'user'
]

const axios = require('axios')

export const apiLireZotero = async (limit=25, index=0, version=0) => {

    const parameters = "?"
        + "sort=dateModified"
        + "&direction=desc"
        + "&limit=" + limit
        + "&start=" + index
        + "&since=" + version

    const headers = {
        'accept': 'application/json',
        'zotero-api-key': key_zotero,
        'zotero-api-version' : api_version_zotero,
    }
    let retour = {};
    await axios({
        method: 'get',
        url: url_base_zotero + parameters,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}

export const apiReferenceZoteroFormateeById = async (id) => {

    const headers = {
        'accept': 'application/json',
        'zotero-api-key': key_zotero,
        'zotero-api-version' : api_version_zotero,
    }
    const parameters = "?"
    + "format=bib"
    + "&style=https://theatradata.mom.fr/theatra.csl"

    let retour = {};
    await axios({
        method: 'get',
        url: url_base_zotero + "/" + id + parameters,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}

export const apiLireZoteroById = async (id) => {

    const headers = {
        'accept': 'application/json',
        'zotero-api-key': key_zotero,
        'zotero-api-version' : api_version_zotero,
    }
    let retour = {};
    await axios({
        method: 'get',
        url: url_base_zotero + "/" + id,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}

export const apiListeDerniersElements = async (typeElement,limit=5) => {
    let retour = {}
    //cas d'un eleemnt inconnu
    if ( ! elements.includes(typeElement)){
        retour.erreur = "Impossble de lire un élement de type " + typeElement
        console.log(retour.erreur)
        return retour
    }

    //recherche dans l'api
    const baseurl = `${apiTheatra}/${typeElement}/last/${limit}`
    const headers = {
        'accept': 'application/json',
    }
    console.log("Je cherche les elements modifés récemment de type " + typeElement)
    await axios({
        method: 'get',
        url: baseurl,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}

export const apiListeElements = async (typeElement,limit=25, index=0) => {
    let retour = {}
    //cas d'un eleemnt inconnu
    if ( ! elements.includes(typeElement)){
        retour.erreur = "Impossble de lire un élement de type " + typeElement
        console.log(retour.erreur)
        return retour
    }

    //recherche dans l'api
    const baseurl = `${apiTheatra}/${typeElement}/limit/${limit}/index/${index}`
    const headers = {
        'accept': 'application/json',
    }
    console.log("Je cherche les elements de type " + typeElement + " de " + index + " par " + limit)
    await axios({
        method: 'get',
        url: baseurl,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}

export const apiSearchElements = async (typeElement, critere=null, limit=25, index=0) => {
    //Affichage avec un elemnt de recherche

    let retour = {}
    //cas d'un eleemnt inconnu
    if ( ! elements.includes(typeElement)){
        retour.erreur = "Impossble de lire un élement de type " + typeElement
        console.log(retour.erreur)
        return retour
    }

    //recherche dans l'api
    const baseurl = `${apiTheatra}/${typeElement}/limit/${limit}/index/${index}`
    const headers = {
        'accept': 'application/json',
    }
    console.log("Je cherche les elements de type " + typeElement + " avec le critere " + critere)
    console.log("Base url " + baseurl)
    const element = {
        body: critere
    }

    await axios({
        method: 'post',
        url: baseurl,
        headers: headers,
        data: element
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}

export const apiListe = async (typeElement, critere) => {
    let retour = {}
    //cas d'un eleemnt inconnu
    if ( ! elements.includes(typeElement)){
        retour.erreur = "Impossble de lire un élement de type " + typeElement
        console.log(retour.erreur)
        return retour
    }

    //recherche dans l'api
    const baseurl = `${apiTheatra}/${typeElement}/critere/${critere}`
    const headers = {
        'accept': 'application/json',
    }
    console.log("Je cherche les elements de type " + typeElement + " avec le critere " + critere)
    await axios({
        method: 'get',
        url: baseurl,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}

export const apiElementById = async (typeElement, id) => {
    let retour = {}
    //cas d'un eleemnt inconnu
    //console.log("Je cherche element de type " + typeElement + " " + id)
    if ( ! elements.includes(typeElement)){
        retour.erreur = "Impossble de lire un élement de type " + typeElement
        console.log(retour.erreur)
        return retour
    }

    const baseurl = `${apiTheatra}/${typeElement}/${id}`
    const headers = {
        'accept': 'application/json',
    }
    await axios({
        method: 'get',
        url: baseurl,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}

export const apiCreeElement = async(typeElement, element) => {
    let retour = {}

    const baseurl = `${apiTheatra}/${typeElement}`
    const headers = {
        'accept': 'application/json',
    }
    await axios({
        method: 'post',
        url: baseurl,
        headers: headers,
        body: element
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}


//critere sous la forme (nomParam=param&)
export const apiElementByCritere = async(typeElement, critere) => {
    let retour = {}

    const baseurl = `${apiTheatra}/${typeElement}/critere/`
    const headers = {
        'accept': 'application/json',
    }

    await axios({
        method: 'get',
        url: baseurl,
        params: critere,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error + " requete base " + JSON.stringify(critere))
    })
    return retour
}


export const apiLireTheatreNuxeo = async (limit=25, index=0) => {
    const baseurl = "https:///nuxeo.mom.fr/nuxeo/api/v1/search/lang/NXQL/execute?";
    const racinePath = '/default-domain/RacineMom/IRAA/Theatra/Les%20données/Théâtres/Pays'

    const query = "select * from Document where ecm:path startswith '" + racinePath + "' AND ecm:currentLifeCycleState!='deleted'"
        + "&pageSize=" + limit
        + "&currentPageIndex=" + index
    const headers = {
        'accept': 'application/json',
        'authorization': authorization_nuxeo,
        'x-nxrepository': 'default',
        'properties': '*'
    }
    let retour = {};
    await axios({
        method: 'get',
        url: baseurl + "query=" + query,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(retour.erreur)
    })
    return retour
}

export const apiLireNoticesNuxeo = async (limit=25, index=0) => {
    const baseurl = "https:///nuxeo.mom.fr/nuxeo/api/v1/search/lang/NXQL/execute?";
    const racinePath = '/default-domain/RacineMom/IRAA/Theatra/Les%20données/Notices'

    const query = "select * from Document where ecm:path startswith '" + racinePath + "' AND ecm:currentLifeCycleState!='deleted'"
        + "&pageSize=" + limit
        + "&currentPageIndex=" + index
    const headers = {
        'accept': 'application/json',
        'authorization': authorization_nuxeo,
        'x-nxrepository': 'default',
        'properties': '*'
    }
    let retour = {};
    await axios({
        method: 'get',
        url: baseurl + "query=" + query,
        headers: headers,
    })
    .then((reponse) => {
        retour.reponse = reponse.data
    })
    .catch((error) => {
        retour.erreur = error.response ? error.response.statusText : error.message
        console.log(error)
    })
    return retour
}
